import React from 'react';
import Nabvar from '../Components/Navbar/Navbar';
import { Outlet } from 'react-router-dom';
import { useMediaQuery } from '@react-hook/media-query';
import Footer from '../Components/Footer/Footer';
import BtnWhatsapp from '../Components/BtnWhatsapp/BtnWhatsapp';
import Cart from '../Components/Cart/Cart';
import ClienteMesa from '../Components/ClienteMesa/ClienteMesa';

export default function PagesLayaut() {
    const isScreenLarge = useMediaQuery('(min-width: 900px)');
    return (
        <div>
            <ClienteMesa />
            {isScreenLarge ?
                <>
                    <Nabvar />
                    <Outlet />
                    <Footer />
                    <BtnWhatsapp />
                    <Cart />
                </> :
                <>
                    <Outlet />
                    <Footer />
                    <Cart />
                </>}
        </div>
    );
}
